import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { ReactNode } from 'react';

import { SUBTLE_CARD_BOX_SHADOW } from '~tread-agent/confirmationCardStyles';

export function ApplyingIndicator() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        gap: 0.5,
        justifyContent: 'flex-end',
      }}
    >
      <CircularProgress size={14} />
      <Typography
        sx={{
          color: theme.brandV2.colors.treadGray3,
          fontSize: '12px',
          fontWeight: 500,
        }}
      >
        {t('tread_agent.confirmation.applying')}
      </Typography>
    </Box>
  );
}

export default function ConfirmationCardShell({
  children,
  dataTestId,
}: {
  children: ReactNode;
  dataTestId?: string;
}) {
  const theme = useTheme();

  return (
    <Card
      data-test-id={dataTestId}
      elevation={0}
      sx={{
        border: `1px solid ${theme.brandV2.colors.treadGray7}`,
        borderRadius: theme.brandV2.borderRadius,
        boxShadow: SUBTLE_CARD_BOX_SHADOW,
        width: '100%',
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.25,
          // CardContent adds 24px bottom padding to its last child, which this overrides.
          p: 1.5,
          '&:last-child': { pb: 1.5 },
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
}
